import Icon from 'components/Icon';
import {IconType} from 'components/Icon/types';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';

type PasswordResult = {
    label: string;
    valid: boolean;
};

export const checkPasswordConditions = (text = '') => {
    const results: PasswordResult[] = [
        {
            label: t`At least 8 characters`,
            valid: text.length >= 8,
        },
        {
            label: t`At least 1 letter`,
            valid: /(?=.*[A-Za-z])/.test(text),
        },
        {
            label: t`At least 1 number`,
            valid: /(?=.*\d)/.test(text),
        },
        {
            label: t`At least 1 symbol (Choose from: !_+.-,$'=@;*:"(&)?[^]%~#)`,
            valid: /(?=.*[!"#$%&'()*+,.:;=?@[\]^_~-])/.test(text),
        },
    ];

    return {
        results,
        valid: results.every(({valid}) => valid),
    };
};

type ConditionTheme = 'default' | 'error' | 'passed';

const TEXT_THEMES: Record<ConditionTheme, string> = {
    default: 'text-light-secondary',
    error: 'text-coral-700',
    passed: 'text-light-secondary',
};

const ICON_THEMES: Record<ConditionTheme, string> = {
    default: 'text-light-secondary',
    error: 'text-coral-700',
    passed: 'text-green-700',
};

const ICON_TYPES: Record<ConditionTheme, IconType> = {
    default: 'success',
    error: 'error',
    passed: 'success_solid',
};

const getTheme = (showErrors: boolean, valid: boolean) =>
    showErrors && !valid ? 'error' : valid ? 'passed' : 'default';

const PasswordRules = ({
    showErrors,
    value,
}: {
    showErrors: boolean;
    value: string;
}) => (
    <div>
        {checkPasswordConditions(value).results.map((data) => {
            const theme = getTheme(showErrors, data.valid);

            return (
                <div
                    className={twMerge(
                        'flex items-center pt-1 text-sm',
                        TEXT_THEMES[theme],
                    )}
                    key={data.label}
                >
                    <Icon
                        className={twMerge(
                            'mr-2 flex-none',
                            ICON_THEMES[theme],
                        )}
                        icon={ICON_TYPES[theme]}
                        size="base"
                    />
                    {data.label}
                </div>
            );
        })}
    </div>
);

export default PasswordRules;
